var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1881",
    "data-name": "Rectangle 1881",
    width: 32,
    height: 32,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4164",
    "data-name": "Groupe 4164",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4164-2",
    "data-name": "Groupe 4164",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15435",
    "data-name": "Trac\\xE9 15435",
    d: "M16,2.617A13.383,13.383,0,1,1,2.616,16,13.383,13.383,0,0,1,16,2.617M16,0A16,16,0,1,0,32,16h0A16,16,0,0,0,16,0",
    transform: "translate(0 0)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15436",
    "data-name": "Trac\\xE9 15436",
    d: "M23.73,10.4A13.383,13.383,0,1,1,10.346,23.78,13.383,13.383,0,0,1,23.73,10.4",
    transform: "translate(-7.696 -7.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15437",
    "data-name": "Trac\\xE9 15437",
    d: "M47.541,39.577a2.376,2.376,0,0,1,.491-1.436,9.288,9.288,0,0,1,1.446-1.487A10.1,10.1,0,0,0,50.8,35.28a2,2,0,0,0,.368-1.2,1.958,1.958,0,0,0-1.91-2h-.077a2.076,2.076,0,0,0-1.422.544,3.568,3.568,0,0,0-.957,1.586l-2.157-.941A5.037,5.037,0,0,1,46.376,30.6a4.639,4.639,0,0,1,2.907-.928,4.968,4.968,0,0,1,2.292.532,4.166,4.166,0,0,1,1.655,1.5,3.993,3.993,0,0,1,.612,2.18,3.69,3.69,0,0,1-.539,1.97,8.777,8.777,0,0,1-1.642,1.869A13.808,13.808,0,0,0,50.3,39.05a1.542,1.542,0,0,0-.38,1,2.867,2.867,0,0,0,.1.668H47.814a2.745,2.745,0,0,1-.273-1.144m1.471,6.986a1.861,1.861,0,0,1-1.36-.544,1.835,1.835,0,0,1-.552-1.362,1.878,1.878,0,0,1,.552-1.375,1.84,1.84,0,0,1,1.36-.557,1.873,1.873,0,0,1,1.913,1.831c0,.034,0,.068,0,.1a1.837,1.837,0,0,1-.55,1.362A1.867,1.867,0,0,1,49.012,46.562Z",
    transform: "translate(-33.213 -22.069)",
    fill: "#6639b7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.1c539fef07f22e1fc32e04be44896139.svg";
export { ForwardRef as ReactComponent };